import { toSafeString } from './toSafeString.js';

export const toSafeLowerString = (value) => {
  return toSafeString(value).toLowerCase();
};
